/* eslint-disable */
import Vue from "vue";
import moment from "moment";
import store from "@/store/index";
import io from "@/plugins/socket";
import { directions, roles } from "./names";

moment.locale("ru");

export const isAuthenticated = (to, from, next) =>
  store.state.user.data.token ? next() : next({ name: "auth" });
export const emailValid = val =>
  /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(
    val
  );
export const mediaQuery = () => {
  if (window) {
    let width = window.innerWidth;
    if (width > 1280) return "laptop";
    if (width > 768 && width < 1279) return "tablet";
    if (width <= 768) return "mobile";
  }
};
export const LS = {
  get(name) {
    return localStorage.getItem(name)
      ? JSON.parse(localStorage.getItem(name))
      : {};
  },
  set(name, data) {
    localStorage.setItem(name, JSON.stringify(data));
  },
  del(name) {
    localStorage.removeItem(name);
  },
  add(name, data) {
    this.set(name, Object.assign(this.get(name), data));
  }
};
export const processFileUpload = (input_files, fileExts, square, subUrl) => {
  return new Promise((resolve, reject) => {
    let image = fileExts; //['jpeg', 'jpg', 'png'];

    let formData = new FormData(),
      filesData = [],
      fileName,
      fileExt;

    for (let file in input_files) {
      if (input_files.hasOwnProperty(file)) {
        formData.append("upload", input_files[file]);

        fileExt = input_files[file].name
          .split(".")
          .pop()
          .toLowerCase();
        fileName = input_files[file].name;

        if (image.includes(fileExt)) {
          let mediasParams = { ext: fileExt };
          if (square) mediasParams.square = true;
          if (subUrl) mediasParams.suburl = subUrl;

          formData.append("params", JSON.stringify(mediasParams));

          filesData.push({ ext: fileExt, name: fileName });
        } else return reject("Файл не поддерживается для этого плэйсмента");
      }
    }
    resolve([formData, filesData]);
  });
};

Vue.prototype.$socket = io;
Vue.prototype.$moment = moment;
Vue.prototype.$LS = LS;
Vue.prototype.$directions = directions;
Vue.prototype.$roles = roles;
Vue.prototype.$mediaQuery = mediaQuery;
Vue.prototype.$API_URL = process.env.VUE_APP_API_URL;
Vue.prototype.$sortBy = (arr, type) =>
  arr.slice().sort((a, b) => a[type] - b[type]);
Vue.prototype.$onlyNumber = ev =>
  (ev.currentTarget.value = ev.currentTarget.value
    .replace(/[^0-9.]/g, "")
    .replace(/(\..*)\./g, "$1"));

Vue.prototype.$processFileUpload = processFileUpload;
Vue.prototype.$avatarError = ev => (ev.target.src = "/default_image.png");
Vue.prototype.$IMAGE = url => `${process.env.VUE_APP_API_URL}${url}`;

Vue.prototype.$formatNumber = num => {
  if (num) {
    try {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    } catch (e) {
      void e;
      return num;
    }
  }
};

export function average(nums) {
  if (nums.length === 0) {
    return 0;
  }
  return nums.reduce((a, b) => a + b) / nums.length;
}

export function processPayoutArray(arr) {
  return arr.map(s => {
    let val = 0;
    s.days.map(
      d =>
        (val = val + (d.payout || 0) + (d.cashout || 0) + (d.cardout || 0))
    );
    return val;
  });
}